import { useMemo } from "react";
import { ISelectOption } from "types/selectLabel";

export const useMapSelectOptions = <T>(
    array: T[],
    idKey: keyof T,
    labelKey: keyof T
): ISelectOption[] => {
    return useMemo(() => {
        if (!array || array.length === 0) return [];
        return array.map(item => ({
            id: item[idKey] as number,
            label: item[labelKey] as string,
        }));
    }, [array, idKey, labelKey]);
};
